//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    active: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    preorder: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    wide: { type: Boolean, default: false }
  },

  computed: {
    classes () {
      return {
        TechOption: true,
        'TechOption--expanded': this.expanded,
        'TechOption--active': this.active,
        'TechOption--preorder': this.preorder,
        'TechOption--disabled': this.disabled,
        'TechOption--wide': this.wide
      }
    }
  }
}
